import WeatherApp from './components//WeatherApp/WeatherApp';
import 'reset-css';
import 'normalize.css';
import './App.css';
import './styles/global.scss'

function App() {
  return (
    <>
      <WeatherApp />
    </>
  );
}

export default App;
